<template>
  <div class="diecut">
    <DiecutList />
  </div>
</template>

<script>
// @ is an alias to /src
import DiecutList from "@/components/DiecutList.vue";

export default {
  name: "Diecut",
  components: {
    DiecutList
  }
};
</script>
